(function () {
  const CUP_STEPS = { A: 1, B: 2, C: 3, D: 4, DD: 5, E: 5, DDD: 6, F: 6, DDDD: 7, G: 8, H: 9, I: 10, J: 11, K: 12, L: 13, M: 14 };
  const EDGES = [33.5, 35, 37, 40, 42];
  const SIZES = ['S', 'M', 'L', 'XL', '2XL', '3XL'];
  const GARMENT_WIDTHS = { S: 68, M: 73, L: 78, XL: 83, '2XL': 88, '3XL': 96 };

  function recommendedSize(band, cup) {
    const bust = Number(band) + CUP_STEPS[cup];
    let index = 0;
    while (index < EDGES.length && bust >= EDGES[index]) index += 1;

    const bandCm = Number(band) * 2.54;
    while (index < SIZES.length - 1 && GARMENT_WIDTHS[SIZES[index]] * 1.25 < bandCm) index += 1;
    return SIZES[index];
  }

  function initialise(root) {
    if (root.dataset.clSizeReady === 'true') return;
    root.dataset.clSizeReady = 'true';

    let selectedBand = '';
    let selectedCup = '';
    const result = root.querySelector('[data-cl-size-result]');
    const value = root.querySelector('[data-cl-size-value]');
    const note = root.querySelector('[data-cl-size-note]');
    const action = root.querySelector('[data-cl-size-action]');

    function select(selector, active) {
      root.querySelectorAll(selector).forEach((button) => {
        const pressed = button === active;
        button.classList.toggle('is-selected', pressed);
        button.setAttribute('aria-pressed', String(pressed));
      });
    }

    function update() {
      if (!selectedBand || !selectedCup) {
        result.hidden = true;
        return;
      }
      const size = recommendedSize(selectedBand, selectedCup);
      value.textContent = size;
      note.textContent = `D’après un soutien-gorge ${selectedBand}${selectedCup}.`;
      action.textContent = `Choisissez ${size} ci-dessous lorsque vous sélectionnez vos coloris.`;
      result.hidden = false;
    }

    root.querySelectorAll('[data-cl-band]').forEach((button) => {
      button.addEventListener('click', () => {
        selectedBand = button.dataset.clBand;
        select('[data-cl-band]', button);
        update();
      });
    });

    root.querySelectorAll('[data-cl-cup]').forEach((button) => {
      button.addEventListener('click', () => {
        selectedCup = button.dataset.clCup;
        select('[data-cl-cup]', button);
        update();
      });
    });
  }

  function initialiseAll(scope) {
    scope.querySelectorAll('[data-cl-size-finder]').forEach(initialise);
  }

  document.addEventListener('DOMContentLoaded', () => initialiseAll(document));
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
